import {Collapse, Grid} from '@material-ui/core';
import {Alert} from '@material-ui/lab';
import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import Loading from 'Shared/components/Loading';
import ScrollToTop from 'Shared/components/ScrollToTop';
import {List as ImmutableList} from 'immutable';
import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {PlanForm} from './PlanForm';
import {PlanSelection} from './PlanSelection';
import {SelectPlansSidebar} from './SelectPlansSidebar';

export const PlansTab = () => {
  const [showPlanSelectionWindow, setShowPlanSelectionWindow] = useState(false);
  const [infoPopupOpen, setInfoPopupOpen] = useState(false);
  const {selectedProduct, isLoadingPlanForm} = useSelector((state: ReducerState) => state.quoteForm);

  const {getQuoteFieldValue} = useQuoteField();
  const quotePlans = getQuoteFieldValue('benefitPackagingDetail.plans');

  const shouldShowInfoPopup = ImmutableList.isList(quotePlans) && quotePlans.size > 0;

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (shouldShowInfoPopup) {
      setInfoPopupOpen(true);
      timer = setTimeout(() => setInfoPopupOpen(false), 5000);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [shouldShowInfoPopup]);

  const isSelectingPlan =
    showPlanSelectionWindow && (!quotePlans || (ImmutableList.isList(quotePlans) && quotePlans.size === 0));

  return isLoadingPlanForm ? (
    <Loading />
  ) : (
    <>
      {infoPopupOpen && (
        <div style={{display: 'flex', flexDirection: 'row-reverse', padding: '1rem 0'}}>
          <Collapse in={infoPopupOpen} timeout={150} style={{maxWidth: '50%'}}>
            <Alert onClose={() => setInfoPopupOpen(false)} severity="info">
              Enter information for all fields highlighted in blue.
            </Alert>
          </Collapse>
        </div>
      )}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={4} lg={3}>
          <SelectPlansSidebar
            onClickAddPlan={() => setShowPlanSelectionWindow(true)}
            selectedProductName={selectedProduct?.name ?? ''}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={8} lg={9}>
          {isSelectingPlan ? (
            <PlanSelection onCancel={() => setShowPlanSelectionWindow(false)} />
          ) : (
            <>{ImmutableList.isList(quotePlans) && quotePlans.size > 0 ? <PlanForm /> : null}</>
          )}
        </Grid>
        <ScrollToTop />
      </Grid>
    </>
  );
};
